import { useState, useReducer, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { AuthReducer } from '../../reducers/auth/AuthReducer';
import * as types from '../../constants/types/auth/AuthTypes';
import * as url from '../../services/api/auth/AuthUrl';

// eslint-disable-next-line import/prefer-default-export
export const useAuth = () => {
  const loginState = { email: '', password: '' };
  const forgotState = { email: '' };
  const resetState = { password: '', confirm: '' };

  const [login, setLogin] = useState(loginState);
  const [forgot, setForgot] = useState(forgotState);
  const [reset, setReset] = useState(resetState);

  const [
    {
      isLoading,
      isSuccess,
      isSuccessMessage,
      isFail,
      isFailMessage,
      token,
      isError,
      isErrorMessage,
    },
    dispatch,
  ] = useReducer(AuthReducer, {
    isLoading: false,
    isSuccess: false,
    isSuccessMessage: '',
    isFail: false,
    isFailMessage: '',
    token: false,
  });

  const onLoginChange = (e) => {
    const { name, value } = e.target;
    setLogin({
      ...login,
      [name]: value,
    });
  };

  const onForgotChange = (e) => {
    const { name, value } = e.target;

    setForgot({
      ...forgot,
      [name]: value,
    });
  };

  const onResetChange = (e) => {
    const { name, value } = e.target;

    setReset({
      ...reset,
      [name]: value,
    });
  };

  const loginUser = async (user, history) => {
    dispatch({
      type: types.START_LOGIN_USER,
    });

    if (user) {
      const { email, password } = user;

      const data = {
        email,
        password,
      };

      try {
        const response = await axios.post(`${url.LOGIN_URL}`, data);
        // eslint-disable-next-line no-underscore-dangle
        if (response.data._token) {
          // eslint-disable-next-line no-underscore-dangle
          sessionStorage.setItem('token', response.data._token);
          sessionStorage.setItem('email', email);
          setLogin(loginState);

          history.push('/');
          dispatch({
            type: types.STOP_LOGIN_USER,
          });
        }
      } catch (e) {
        if (e.response) {
          if (e.response.data.message === 'invalid credentials') {
            toast.error(e.response.data.message);
            dispatch({
              type: types.LOGIN_USER_FAIL,
            });
          } else {
            dispatch({
              type: types.LOGIN_USER_FAIL,
              payload: false,
            });
          }
        }
      }
    }
  };

  const forgotPassword = async (data) => {
    dispatch({
      type: types.START_FORGET_PASSWORD,
    });

    try {
      const response = await axios.post(`${url.FORGOT_PASSWORD_URL}`, data);
      switch (response.data.status) {
        case 'success':
          toast.success(response.data.message.toUpperCase());
          dispatch({
            type: types.FORGET_PASSWORD_SUCCESSFUL,
            payload: response.data.message,
          });
          setForgot(forgotState);
          break;

        case 'failed':
          toast.info(response.data.message);
          dispatch({
            type: types.UNABLE_TO_FORGET_PASSWORD,
            payload: response.data.message,
          });
          break;

        default:
          dispatch({
            type: types.UNABLE_TO_FORGET_PASSWORD,
            payload: 'Unable to send email!',
          });
      }
    } catch (e) {
      if (e) {
        toast.success('Something went wrong!');
        dispatch({
          type: types.STOP_FORGET_PASSWORD,
          payload: 'Something went wrong!',
        });
      }
    }
  };

  const resetPassword = async (data, id, history) => {
    dispatch({
      type: types.START_RESET_PASSWORD,
    });
    const change = {
      password: data.password,
      confirm_password: data.password,
      token: id,
    };
    try {
      const response = await axios.post(`${url.RESET_PASSWORD_URL}`, change);

      if (
        response.data.message === 'Password reset successful' &&
        response.data.status === 'success'
      ) {
        dispatch({
          type: types.RESET_PASSWORD_SUCCESSFUL,
        });
        toast.success(response.data.message);
        history.push('/login');
      } else {
        dispatch({
          type: types.STOP_RESET_PASSWORD,
        });
        toast.info('Something went wrong!');
      }
    } catch (e) {
      if (
        e.response.data.message === 'link has expired, please reset' &&
        e.response.data.status === 'failed'
      ) {
        dispatch({
          type: types.UNABLE_TO_RESET_PASSWORD,
        });
        toast.info(e.response.data.message);

        setTimeout(() => {
          history.push('/forgot-password');
        }, 2000);
      }
    }
  };

  useEffect(() => {
    const checkIfLoggedIn = () => {
      if (sessionStorage.getItem('token')) {
        dispatch({
          type: types.CHECK_IF_TOKEN_EXISTS,
          payload: true,
        });
      }
    };

    checkIfLoggedIn();
  }, []);
  return {
    onLoginChange,
    loginUser,
    onForgotChange,
    forgotPassword,
    onResetChange,
    resetPassword,
    login,
    forgot,
    reset,
    isSuccess,
    isSuccessMessage,
    isFail,
    isFailMessage,
    isLoading,
    token,
    isError,
    isErrorMessage,
  };
};
